import {remCalc} from '../../../_utils'

const productTileCart = {
    ProductTileCart: {
        baseStyle: ({disabled}: {disabled: boolean}) => ({
            wrapper: {
                w: 'full',
                py: {base: 'spacing.4', md: 'spacing.6'},
                gap: 'spacing.3',
            },
            header: {
                justifyContent: 'space-between',
                alignItems: 'center',
                w: 'full',
                gap: 'spacing.4',
                my: remCalc(-6),
            },
            footer: {
                justifyContent: {md: 'space-between'},
                direction: {base: 'column', md: 'row'},
                w: 'full',
                gap: 'spacing.5',
            },
            body: {
                w: '100%',
                justifyContent: 'flex-start',
                alignItems: 'stretch',
                gap: 'spacing.6',
                opacity: disabled ? 0.5 : 1,
            },
            informationsWrapper: {
                alignItems: 'start',
                gap: 'spacing.3',
                flex: 1,
            },
            image: {
                w: remCalc(120),
                maxW: remCalc(120),
                minW: {md: remCalc(120)},
                flex: 1,
            },
            productInformations: {
                gap: remCalc(6),
                alignItems: 'flex-start',
            },
            name: {
                textStyle: {base: 'paragraphMd', md: 'paragraphSm'},
                fontWeight: '400',
            },
            sizeAndColor: {
                textStyle: 'paragraphSm',
                fontWeight: '300',
            },
            disabledProductLabel: {
                textStyle: 'paragraphSm',
                fontWeight: '300',
                color: 'color.border.error',
            },
            sku: {
                textStyle: 'paragraphXs',
                fontWeight: 400,
                color: 'color.border.grey.600',
                wordBreak: 'break-all',
            },
            priceSection: {
                textStyle: 'paragraphSm',
                fontWeight: 400,
                gap: 'spacing.1',
                letterSpacing: remCalc(3.5),
                whiteSpace: 'nowrap',
                opacity: disabled ? 0.5 : 1,
                textAlign: 'left',
                alignItems: {base: 'flex-end', md: 'unset'},
            },
            fullPrice: {
                textDecoration: 'line-through',
            },
        }),
    },
}

export default productTileCart
